
import { IResourceComponentsProps, useExport } from "@pankod/refine-core";

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  useTable,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm, Icons, Menu,
} from "@pankod/refine-antd";




import { IAspect } from "interfaces";
import { CreateAspect } from "./create";
import { EditAspect } from "./edit";
const { PlusOutlined } = Icons;

export const AspectsList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, sorter, tableQueryResult } = useTable<IAspect>({
    initialPageSize: 1000,
    initialSorter: [
      {
        field: "sort_id",
        order: "asc",
      },
    ],
    metaData: {
      fields: ["id", "name", "aspects_id", "created_at", { competency: ["name"], },]
    },
  });
  const { formProps, modalProps, show } = useModalForm({
    resource: "competency_aspects",
    action: "create",
  });
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: "competency_aspects",
    action: "edit",
    metaData: {
      fields: ["id", "name", "aspects_id", "created_at", { competency: ["name"], },]
    },
  });

  const { triggerExport, isLoading } = useExport<IAspect>();


  return (
    <List
      pageHeaderProps={{

        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
        ],

      }}
    >
      <>
        <Menu
          mode="horizontal"
          defaultSelectedKeys={["all"]}
          style={{ background: "#ffffff" }}
        >
          <Menu.Item
            key="all"
            icon={<Icons.AppstoreOutlined />}
          >
            All Competency Aspects
          </Menu.Item>
          <Menu.Item
            key="draft"
            icon={<Icons.AppstoreOutlined />}
          >
            Technical
          </Menu.Item>
          <Menu.Item
            key="review"
            icon={<Icons.AppstoreOutlined />}
          >
            Professional
          </Menu.Item>
          <Menu.Item
            key="approval"
            icon={<Icons.AppstoreOutlined />}
          >
            Core
          </Menu.Item>
          <Menu.Item
            key="published"
            icon={<Icons.AppstoreOutlined />}
          >
            Mindset
          </Menu.Item>

        </Menu>
      </>
      <Table {...tableProps} rowKey="id" size="small">
        <Table.Column dataIndex="id" title="Id" />
        {/* <Table.Column<IAspect>
                    dataIndex="competency_id"
                    render={(_, record) => record?.competency?.type?.id}
                    title="Competency Type" /> */}
        <Table.Column<IAspect>
          dataIndex="competency_id"
          render={(_, record) => record.competency.name}
          title="Competency" />
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column<IAspect>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                onClick={() => editShow(record.id)}
              />
              <DeleteButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
              />
            </Space>
          )}
        />
      </Table>
      <CreateAspect modalProps={modalProps} formProps={formProps} />
      <EditAspect modalProps={editModalProps} formProps={editFormProps} />

    </List>
  );
};
